












































































































































































































































































































































































































import Vue from "vue";
import {onBeforeMount, ref, computed} from "@vue/composition-api";
import moment from "moment";
import AirBar from "../../components/AirBar";
import AirBarGrey from "../../components/AirBarGrey";
import formatDate from "../../helpers/formatDate";
import formatScheduleDate from "../../helpers/formatScheduleDate";
import formatCurrency from "../../helpers/formatCurrency";
import {
  dateRanges,
  abandonedCheckoutOptions,
  reactivationOptions,
} from "../../helpers/consts";
import appBridge from "../../helpers/appBridge";
import _ from "lodash";

export default Vue.extend({
  name: "Dashboard",
  components: {
    AirBar,
    AirBarGrey,
  },
  data: () => ({}),
  setup(props, context: any): any {
    const selectedDateRange = ref(604800);

    const loadingGraph = ref(false);
    const metrics = ref([]);
    const labels = ref([]);
    const dataOne = ref([]);
    const dataTwo = ref([]);
    const dataThree = ref([]);
    const dataFour = ref([]);
    const storeOrderCount = ref(0);
    const storeRevenue = ref("0");
    const metricsRevenue = ref([]);
    function getDateRange() {
      const currentTimestamp = Math.round(+new Date());
      const previousTimeStamp =
        currentTimestamp - selectedDateRange.value * 1000;
      return {
        startDate: {
          year: moment(previousTimeStamp).year(),
          month: moment(previousTimeStamp).month() + 1,
          day: moment(previousTimeStamp).date(),
        },
        endDate: {
          year: moment(currentTimestamp).year(),
          month: moment(currentTimestamp).month() + 1,
          day: moment(currentTimestamp).date(),
        },
      };
    }

    const campaignsList = computed(() =>
      context.root.$store.state.campaigns.campaignsList.data.slice(0, 5)
    );
    const customerCount = computed(
      () => context.root.$store.state.shop.customerCount
    );
    const subscriberCount = computed(
      () => context.root.$store.state.shop.subscriberCount
    );
    const subPercentage = computed(() =>
      Math.round(
        (context.root.$store.state.shop.subscriberCount /
          context.root.$store.state.shop.customerCount) *
        100
      )
    );

    const orderCount = computed(
      () => context.root.$store.state.shop.orderCount
    );
    const orders = computed(() => context.root.$store.state.shop.orders);

    const sales = computed(() => {
      return _.sumBy(orders.value, function (o) {
        return JSON.parse(o.total_price);
      });
    });

    const store = computed(() => context.root.$store.state.store);

    const automations = computed(
      () => context.root.$store.state.automations.automations.automations
    );
    const automationsReport = computed(
      () => context.root.$store.state.automations.automationsReport.automations
    );

    const automationsReportFiltered = computed(() => {
      const arr = [];
      automations.value.forEach((el) => {
        arr.push({
          ...el,
          rev: _.find(metricsRevenue.value, function (o) {
            return o.filterBy === el.name;
          }),
        });
      });
      return arr;
    });

    function generateGraphLabels(labels) {
      const dateLabels = [];
      moment.locale(store.value.primaryLocale);
      labels.forEach((element) => {
        const label = `${moment(
          new Date(
            element.year,
            element.month < 10 ? 0 + element.month - 1 : element.month - 1,
            element.day < 10 ? 0 + element.day : element.day
          )
        ).format("L")}`;
        dateLabels.push(label);
      });
      return dateLabels;
    }

    const clubLogic = ref(false);
    const clubLogicAlt = ref(false);

    function getReports() {
      metrics.value = [];
      loadingGraph.value = false;
      context.root.$store
        .dispatch("shop/getStoreReport", getDateRange())
        .then((res) => {
          dataOne.value = res.series[4].data;
          dataTwo.value = res.series[5].data;
          dataThree.value = res.series[6].data;
          dataFour.value = res.series[7].data;
          labels.value = generateGraphLabels(res.labels);
          loadingGraph.value = true;
          res.metrics.forEach((el) => {
            switch (el.type) {
              case "MESSAGE_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Sent",
                  icon: "$vuetify.icons.send",
                  order: 4,
                });
                break;
              case "COST":
                metrics.value.push({
                  value: `${formatCurrency(
                    el.value.toFixed(2),
                    store.value.primaryLocale + "-" + store.value.countryCode,
                    store.value.primaryCurrencyCode
                  )}`,
                  label: "Cost",
                  icon: "$vuetify.icons.trenddown",
                  order: 3,
                });
                break;
              case "ORDER_COUNT":
                if (el.filterBy) {
                  storeOrderCount.value = el.value;
                  return;
                }
                metrics.value.push({
                  value: el.value,
                  label: "Orders",
                  icon: "$vuetify.icons.basketsimple",
                  order: 5,
                });
                break;
              case "REVENUE":
                if (el.filterBy && el.filterBy !== "ALL") {
                  metricsRevenue.value.push(el);
                  return;
                }
                if (el.filterBy === "ALL") {
                  storeRevenue.value = formatCurrency(
                    el.value.toFixed(2),
                    store.value.primaryLocale + "-" + store.value.countryCode,
                    store.value.primaryCurrencyCode
                  );
                  return;
                }
                metrics.value.push({
                  value: `${formatCurrency(
                    el.value.toFixed(2),
                    store.value.primaryLocale + "-" + store.value.countryCode,
                    store.value.primaryCurrencyCode
                  )}`,
                  label: "Revenue",
                  icon: "$vuetify.icons.trendup",
                  order: 1,
                });
                break;
              case "ROI":
                metrics.value.push({
                  value: `${Math.round(el.value * 100)}%`,
                  label: "ROI",
                  icon: "$vuetify.icons.percentagegrey",
                  order: 0,
                });
                if (Math.round(el.value * 100) > 1000) {
                  clubLogic.value = true;
                }
                if (Math.round(el.value * 100) > 20) {
                  clubLogicAlt.value = true;
                }
                break;
              case "UNSUBSCRIBE_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Unsubscribes",
                  icon: "$vuetify.icons.person",
                  order: 6,
                });
                break;
              case "UNIQUE_CLICK_COUNT":
                // metrics.value.push({
                //   value: el.value,
                //   label: "Unique Clicks",
                //   icon: "$vuetify.icons.group",
                //   order: 8
                // });
                break;
              case "CLICK_COUNT":
                metrics.value.push({
                  value: el.value,
                  label: "Total Clicks",
                  icon: "$vuetify.icons.group",
                  order: 7,
                });
                break;
              case "CLICK_THROUGH_RATE":
                metrics.value.push({
                  value: `${Math.round(el.value * 100)}%`,
                  label: "Click Through Rate",
                  icon: "$vuetify.icons.group",
                  order: 9,
                });
                break;
            }
          });

          metrics.value = _.orderBy(metrics.value, "order", "asc");
        });

      context.root.$store.dispatch(
        "automations/getAutomationsReport",
        getDateRange()
      );
    }

    onBeforeMount(() => {
      context.root.$store.dispatch("campaigns/resetCampaignList");
      context.root.$store.dispatch("automations/getAutomations");
      context.root.$store.dispatch("campaigns/getCampaignsList", {});
      getReports();
      context.root.$mixpanel.track("Page Load", {Page: "Dashboard"});
    });

    function statusColor(status) {
      let color = "";
      switch (status) {
        case "CANCELLED":
          color = "warning";
          break;
        case "SENDING":
          color = "info";
          break;
        case "SENT":
          color = "success";
          break;
        case "DRAFT":
          color = "lightgray";
          break;
      }
      return color;
    }

    function filterFriendlyAutomation(automation) {
      if (automation.trigger === "ABANDONED_CHECKOUT") {
        const delay = _.find(abandonedCheckoutOptions, function (o) {
          return o.value === automation.delay;
        });
        return `Abandoned cart notification after ${delay ? delay.text : "-"}`;
      } else if (automation.trigger === "CUSTOMER_REACTIVATION") {
        const delay = _.find(reactivationOptions, function (o) {
          return o.value === automation.delay;
        });
        return `Customer winback after ${delay ? delay.text : "-"}`;
      } else {
        return "Shipping notifications";
      }
    }

    const loading = computed(() => context.root.$store.state.loading);
    const loadingSubs = computed(() => context.root.$store.state.loadingSubs);
    const loadingSubsFailed = computed(
      () => context.root.$store.state.loadingSubsFailed
    );

    function redirectTo(url) {
      appBridge(context.root.$store.state.store).redirectToRemote(url);
    }

    return {
      redirectTo,
      clubLogicAlt,
      loadingSubsFailed,
      loadingSubs,
      clubLogic,
      dataFour,
      store,
      storeOrderCount,
      storeRevenue,
      loading,
      filterFriendlyAutomation,
      metrics,
      selectedDateRange,
      campaignsList,
      dateRanges,
      statusColor,
      subPercentage,
      customerCount,
      subscriberCount,
      orderCount,
      automationsReportFiltered,
      dataOne,
      dataTwo,
      dataThree,
      labels,
      loadingGraph,
      getReports,
      sales,
    };
  },
});
